import { combineReducers } from 'redux';
import { SET_CURRENT_OUTLET, SET_OUTLETS } from 'actions/outlet/constants';
import createReducer from 'utils/createReducer';

const currentOutlet = createReducer([], {
  [SET_CURRENT_OUTLET]: (draft, { payload }) => payload.data.selected_outlets,
});

const outlets = createReducer([], {
  [SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

export default combineReducers({
  currentOutlet,
  outlets,
});
